import React from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {Helmet} from 'react-helmet'
import {Box} from '@chakra-ui/react'

const BounceExchange = () => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {enableBounceX} = commerceAPI.storefront
    const {config} = commerceAPI.oneTrust || {}

    var oneTrustEnable = false

    try {
        oneTrustEnable = JSON.parse(config).enabled
    } catch (e) {
        console.log(e.message)
    }

    return (
        <Box>
            {enableBounceX && (
                <Helmet>
                    {oneTrustEnable ? (
                        <script type="text/plain" className="optanon-category-C0004">
                            {`(function(d) { var e = d.createElement('script'); e.src = d.location.protocol + '//tag.bounceexchange.com/2791/i.js'; e.async = true; d.getElementsByTagName("head")[0].appendChild(e); }(document));`}
                        </script>
                    ) : (
                        <script>
                            {`(function(d) { var e = d.createElement('script'); e.src = d.location.protocol + '//tag.bounceexchange.com/2791/i.js'; e.async = true; d.getElementsByTagName("head")[0].appendChild(e); }(document));`}
                        </script>
                    )}
                </Helmet>
            )}
        </Box>
    )
}

export default BounceExchange
